import React, { useRef } from 'react';

import { Typography, withStyles, Icon, IconButton } from '@material-ui/core';

const styles = theme => ({
    modalMaxHeightFallback: {
        maxHeight: '100vh'
    },
    modalSplash: {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000,
        height: '100dvh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'auto',
        background: 'rgba(0, 0, 0, 0.6)'
    },
    modalContainer: {
        maxWidth: '600px',
        maxHeight: '100dvh',
        width: '600px',
        padding: '25px 25px 35px 25px',
        background: 'white',
        borderRadius: '4px',
        overflow: 'auto',
        [theme.breakpoints.down('xs')]: {
            padding: '15px 15px 25px 15px'
        }
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&> h5': {
            [theme.breakpoints.down('xs')]: {
                fontSize: '1.3rem'
            }
        }
    },
    breakLine: {
        width: '100%',
        height: '1px',
        background: 'black',
        margin: '0 0 1em'
    }
});

let modalIdCounter = 0;

const Modal = ({ classes, className, children, show, title, onCancel }) => {
    modalIdCounter += 1;
    const titleId = useRef(`modal-title-${modalIdCounter}`).current;

    let containerClasses = `${classes.modalMaxHeightFallback} ${classes.modalContainer}`;
    if (className) {
        containerClasses = `${className} ${containerClasses}`;
    }

    return (
        show && (
            <div
                className={`${classes.modalMaxHeightFallback} ${classes.modalSplash}`}
            >
                <div
                    className={containerClasses}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby={titleId}
                >
                    <div className={classes.modalHeader}>
                        <Typography variant="h5" id={titleId}>
                            {title}
                        </Typography>
                        <IconButton aria-label="close" onClick={onCancel}>
                            <Icon>close</Icon>
                        </IconButton>
                    </div>

                    <div className={classes.breakLine} />

                    {children}
                </div>
            </div>
        )
    );
};

export default withStyles(styles)(Modal);
